import useHistoryTableFilterStore from 'src/stores/historyTableFilterStore/useHistoryTableFilterStore';
import PortfolioHistoryTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableControls';
import PortfolioHistoryTableMarketFilter from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableMarketFilter';

export default function PortfolioHistoryIFStakingTableControls() {
	const marketFilter = useHistoryTableFilterStore(
		(s) => s.getFilterState('if-staking')['spotMarketSymbol']
	);
	const setHistoryTableFilterState = useHistoryTableFilterStore((s) => s.set);

	const handleMarketFilterChange = (selectedMarket: string) => {
		setHistoryTableFilterState((s) => {
			s['if-staking'].spotMarketSymbol = selectedMarket;
			s['if-staking'].currentUiPage = 0;
		});
	};

	return (
		<PortfolioHistoryTableControls
			historyType="if-staking"
			exportType="if-stake-records"
		>
			<PortfolioHistoryTableMarketFilter
				marketType="spot"
				marketFilter={marketFilter}
				handleMarketFilterChange={handleMarketFilterChange}
				id="portfolio-history-if-staking-table-market-filter"
			/>
		</PortfolioHistoryTableControls>
	);
}
